import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  carBookAsync,
  getCarBookingStatus,
  getLoading,
} from "../../../../features/bookings/carrentSlice";
import SuccessModal from "../../../modals/SuccessModal";
import Loader from "../../../../helpers/Loader";
import { useForm } from "../../../../hooks/useForm";
import { callingCode } from "../../../../helpers/helper";

const Driver = () => {
  // const [state, setState] = useState({
  //   FirstName: "",
  //   LastName: "",
  //   MobileNo: "",
  // });
  const [file, setFile] = useState(null);
  const [fileData, setFileData] = useState({});

  // const [isSubmit, setIsSubmit] = useState(false);
  // const [formErrors, setFormErrors] = useState({});

  const imageRef = useRef();

  const customValidate = (errors, setState) => {
    const myFile = imageRef.current?.files[0];
    var size = parseFloat(myFile?.size / (1024 * 1024)).toFixed(2);

    if (myFile === undefined) {
      errors.image = "Please upload image!";
    } else if (myFile?.type !== "image/jpeg" && myFile?.type !== "image/png") {
      errors.image = "Only jpeg and png images can be uploaded!";
    } else if (size > 2) {
      errors.image = "Image size should be maximum 2mb!";
    } else {
      setState({ ...state, image: myFile });
    }
  };

  const {
    state,
    isSubmit,
    formErrors,
    handleInputChange,
    handleFormSubmit,
    checkErrors,
  } = useForm({
    val: {
      FirstName: "",
      LastName: "",
      MobileNo: "",
      CountryCode: "",
      Email: "",
    },
    inValidate: customValidate,
  });
  //
  const [status, setStatus] = useState("");
  const [msg, setMsg] = useState("");
  const [show, setShow] = useState(false);
  const [isBooked, setIsBooked] = useState(false);

  const [statusCodes, setStatusCode] = useState("");
  const dispatch = useDispatch();
  const bookingStatus = useSelector(getCarBookingStatus);
  const loading = useSelector(getLoading);
  const statusCode = useSelector((state) => state.carrent.status, shallowEqual);
  const { Authorization } = JSON.parse(sessionStorage.getItem("userData"));

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      dispatch(carBookAsync({ state, fileData, Authorization }));
    }
  }, [formErrors, isSubmit]);

  useEffect(() => {
    // if (bookingStatus === false) {
    //   if (parseInt(statusCode) === 300) {
    //     setMsg("Your booking is under process.");
    //   } else {
    //     setMsg("Something went wrong try after sometime");
    //   }
    //   setShow(true);
    //   setStatusCode(statusCode);
    // }

    if (Object?.keys(bookingStatus).length > 0) {
      if (bookingStatus) {
        setStatusCode(statusCode);
        setMsg(
          "Your booking has been Confirmed. Check your emails for details."
        );
        // setStatus("Awesome!");
      } else {
        if (parseInt(statusCode) === 300) {
          setStatusCode(statusCode);
          setMsg("Your booking is under process.");
        } else {
          setStatusCode(statusCode);
          setMsg("Something went wrong try after sometime");
        }
        // setStatus("Failed!");
      }
      setShow(true);
    }
  }, [bookingStatus]);

  // useEffect(() => {

  //   if (isBooked === true) {
  //     if (Object?.keys(bookingStatus).length > 0) {
  //       // if (bookingStatus.success) {
  //       setMsg(
  //         "Your booking has been Proceed.Our Agent will contact you for further process, Check your emails for details."
  //       );
  //       setStatus("Awesome!");
  //       // }
  //     } else {
  //       setMsg("Something Went Wrong!");
  //       setStatus("Failed!");
  //     }
  //     setShow(true);
  //   }
  // }, [bookingStatus]);

  const handleFileChange = (e) => {
    setFileData(e.target.files[0]);
    setFile(URL.createObjectURL(e.target.files[0]));
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="transfer-inner-wrap">
        <h4 className="title mt-5">Main driver's details</h4>
        <div className="review-booking-wrapper guest-details-wrapper">
          <form
            action=""
            className="guest-detail-form"
            encType="multipart/form-data"
          >
            <h5 className="r-b-14">As they appear on driving licence</h5>
            <div className="name-detail">
              <div className="row w-100">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="">First Name</label>
                    <input
                      type="text"
                      placeholder="Enter First Name"
                      name="FirstName"
                      value={state.FirstName}
                      onChange={handleInputChange}
                      // onFocus={(e) => setErrors(e)}
                      onBlur={(e) => checkErrors(e)}
                      autoComplete="off"
                    />
                    <span className="error">{formErrors?.FirstName}</span>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="">Last Name</label>
                    <input
                      type="text"
                      placeholder="Enter Last Name"
                      name="LastName"
                      value={state.LastName}
                      onChange={handleInputChange}
                      // onFocus={(e) => setErrors(e)}
                      onBlur={(e) => checkErrors(e)}
                      autoComplete="off"
                    />
                    <span className="error">{formErrors?.LastName}</span>
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
            <div className="row">
              <div className="col-lg-6">
                <div className="mobile-number">
                  <div className="form-group">
                    <label for="">Mobile Number </label>
                    <div>
                      <div className="position-relative select-country-code">
                        <div className="select-arrow"></div>
                        <select
                          name="CountryCode"
                          onChange={handleInputChange}
                          className="form-control"
                          onBlur={(e) => checkErrors(e)}
                        >
                          <option value=""> Code</option>
                          {callingCode.map((ele, ind) => (
                            <option key={ind} value={ele.label.split(" ")[0]}>
                              {ele.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <input
                        type="text"
                        placeholder="Enter Mobile Number"
                        name="MobileNo"
                        value={state.MobileNo}
                        onChange={handleInputChange}
                        autoComplete="off"
                        onBlur={(e) => checkErrors(e)}
                      />
                    </div>
                    <span className="error">{formErrors?.CountryCode}</span>
                    <span className="error">{formErrors?.MobileNo}</span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="name-detail mobile-number">
                  <div className="form-group">
                    <label htmlFor="">Email Address</label>
                    <input
                      type="text"
                      placeholder="Enter Email Address"
                      name="Email"
                      value={state.Email}
                      onChange={handleInputChange}
                      // onFocus={(e) => setErrors(e)}
                      onBlur={(e) => checkErrors(e)}
                      autoComplete="off"
                    />
                    <span className="error">{formErrors?.Email}</span>
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
            <div className="form-group">
              <label htmlFor="">Upload ID proof</label>
              <label className="form__container w-100" id="upload-container">
                <p>
                  {" "}
                  <img src="assets/images/upload.svg" alt="upload" /> Choose
                  your file{" "}
                </p>
                <input
                  className="form__file"
                  id="upload-files"
                  type="file"
                  //   multiple="multiple"
                  name="file"
                  onChange={handleFileChange}
                  ref={imageRef}
                />
                <div className={file === null ? "d-none" : "id-proof d-block"}>
                  <img src={file} />
                </div>
              </label>
              <span className="error">{formErrors?.image}</span>
            </div>
            {/*  */}
          </form>
        </div>
      </div>
      <div>
        <button
          className="cmn-btn reserve-btn d-block w-100"
          onClick={(e) => {
            handleFormSubmit(e);
            setIsBooked(true);
          }}
        >
          {" "}
          Book car & pay
        </button>
      </div>
      {show ? (
        <SuccessModal
          setShow={setShow}
          show={show}
          msg={msg}
          status={status}
          statusCode={statusCodes}
        />
      ) : null}
    </>
  );
};

export default Driver;
